import React from "react";
import { Container, Col, Row, Accordion, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";



function AppGuidance() {
    const navigate = useNavigate();

    function importAll(r) {
        let images = {};
        r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
        return images
    }

    const images = importAll(require.context('../assets/img', false, /\.(png|jpe?g|svg)$/));


    return (
        <div>
            <Container>
                <Row className="justify-content-center ">
                    <Col xs={12} md={10}>

                        <Row>
                            <Col xs={6} className="py-3">
                                <div className="d-flex rgc-title">
                                    <div className="rgc-title-point"></div>
                                    <h4>راهنمای <span>اپلیکیشن</span></h4>
                                </div>
                            </Col>

                            <Col xs={6} className="rgc-icon-header text-start py-3" >
                                <i className="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
                            </Col>

                            <Col xs={12} >
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای نصب</Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide16.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide17.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>2</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide18.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>3</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای بخش ثبت نام و ورود</Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide1.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide2.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>2</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide3.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>3</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide4.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>4</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای بخش ثبت سفارش</Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide5.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide6.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>2</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide7.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>3</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide9.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>4</span>
                                                    </div>
                                                </Col>

                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide15.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>4</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای بخش تحویل به ایستگاه </Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide10.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای بخش تحویل به راننده</Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide8.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide12.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>2</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide13.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>3</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="5" className="rgc-accordion-item">
                                        <Accordion.Header className="rgc-accordion-header">راهنمای بخش دریافت امتیاز</Accordion.Header>
                                        <Accordion.Body className="rgc-guide">
                                            <Row>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide14.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>1</span>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="rgc-guide-content">
                                                    <Image src={images['guide19.jpg']} />
                                                    <div className="rgc-guide-number">
                                                        <span>2</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default AppGuidance